module.exports = __webpack_public_path__ + "img/logo_s.3cdad345.svg";